import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BundleListComponent } from './bundle-list/bundle-list.component';
import { BundleComponent } from './bundle/bundle.component';

import { AuthGuard } from '@core/utilities/auth.guard';
import { Permission } from '@core/literals/permission.literal';
import { RedeploymentAuthorize } from '../../core/utilities/redeployment-authorize.guard';
import { Organizations } from '../../shared/literals/shared.literal';

const routes: Routes = [
  {
    path: '',
    component: BundleListComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.ViewBundles, undefined))]
  },
  {
    path: 'Bundle/Detail/:id',
    component: BundleComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.ViewBundles, undefined))]
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class BundlesRoutingModule {

}
